import React, { Fragment, useState, useRef, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { Dropdown, Tab, Nav } from "react-bootstrap";
import PageTitle from "../../../../layouts/PageTitle";

const messageBlog = [
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
];
const messageBlog2 = [
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
];
const messageBlog3 = [
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
];

const Inbox = () => {
  const [data, setData] = useState(
    document.querySelectorAll(".email-right-box .email-list .message"),
  );
  const sort = 13;
  const activePag = useRef(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll(".email-right-box .email-list .message"));
    //chackboxFun();
  }, []);
  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  const chackbox = document.querySelectorAll(".message input");
  const motherChackBox = document.querySelector("#checkbox1");
  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };
  return (
    <Fragment>
      <PageTitle activeMenu="Inbox" motherMenu="Email" pageContent="Email" />

      <div className="card p-0 rounded-0 mb-0">
        <div className="row gx-0">
          <div className="col-xl-2 col-xxl-3 col-lg-3">
            <PerfectScrollbar className="email-left-box dlab-scroll  pt-3">
              <div className="p-0">
                <Link to="/email-compose" className="btn text-white btn-block">
                  <i className="fa-solid fa-plus me-2"></i>Compose Email
                </Link>
              </div>
              <div className="mail-list rounded ">
                <Link to="/email-inbox" className="list-group-item active">
                  <i className="fa-regular fa-envelope align-middle"></i>
                  Inbox
                  <span className="badge badge-purple badge-sm float-end rounded">
                    123
                  </span>
                </Link>
                <Link to="/email-compose" className="list-group-item">
                  <i className="fa-regular fa-paper-plane align-middle"></i>
                  Sent
                </Link>
                <Link to="/email-compose" className="list-group-item">
                  <i className="fa-regular fa-star align-middle"></i>
                  Favorite
                  {/* <span className="badge badge-danger text-white badge-sm float-end">
                            47
                          </span> */}
                </Link>
                <Link to="/email-compose" className="list-group-item">
                  <i className="fa-regular fa-file align-middle"></i>
                  Draft
                </Link>
                <Link to="/email-compose" className="list-group-item">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.4425 10.0575L10.065 15.435C9.92569 15.5745 9.76026 15.6851 9.57816 15.7606C9.39606 15.8361
                            9.20087 15.8749 9.00375 15.8749C8.80663 15.8749 8.61144 15.8361 8.42934 15.7606C8.24724 15.6851 8.08181 15.5745 7.9425 15.435L1.5 9V1.5H9L15.4425
                            7.9425C15.7219 8.22354 15.8787 8.60372 15.8787 9C15.8787 9.39628 15.7219 9.77646 15.4425 10.0575Z"
                      stroke="#666666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.25 5.25H5.268"
                      stroke="#666666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Important
                </Link>
                <Link to="#" className="list-group-item">
                  <i className="fa-regular fa-clock align-middle"></i> Scheduled
                </Link>
                <Link to="#" className="list-group-item ">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 8.25L11 13.75L16.5 8.25"
                      stroke="#666666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>{" "}
                  Move
                </Link>
              </div>
              <div className="mail-list rounded overflow-hidden mt-4 ">
                <div className="intro-title d-flex justify-content-between my-0">
                  <h5>Categories</h5>
                </div>
                <Link to="/email-inbox" className="list-group-item change">
                  Work{" "}
                </Link>
                <Link to="/email-inbox" className="list-group-item change">
                  Private{" "}
                </Link>
                <Link to="/email-inbox" className="list-group-item change">
                  Support
                </Link>
                <Link to="/email-inbox" className="list-group-item change">
                  Social
                </Link>
              </div>
            </PerfectScrollbar>
          </div>
          <div className="col-xl-10 col-xxl-9 col-lg-9">
            <div className="email-right-box">
              <Tab.Container defaultActiveKey="Import">
                <div role="toolbar" className="toolbar ms-1 ms-sm-0">
                  <div className="saprat">
                    <div className="d-flex align-items-center">
                      <div className="btn-group">
                        <div className="form-check custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="checkbox1"
                            onClick={() => chackboxFun("all")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="checkbox1"
                          ></label>
                        </div>
                      </div>
                      <Nav
                        as="ul"
                        className="nav nav-pills"
                        id="pills-tab"
                        role="tablist"
                      >
                        <Nav.Item
                          as="li"
                          className="nav-item btn-group"
                          role="presentation"
                        >
                          <Nav.Link
                            as="button"
                            type="button"
                            className="btn effect mx-2 nav-link"
                            id="pills-home-tab"
                            eventKey="Import"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.8798 1.66667H4.21313C3.55032 1.6674 2.91485 1.93102 2.44617 2.3997C1.97748 2.86839 1.71386 3.50385 1.71313 4.16667V15.8333C1.71386 16.4962 1.97748 17.1316 2.44617 17.6003C2.91485 18.069 3.55032 18.3326 4.21313 18.3333H15.8798C16.5426 18.3326 17.1781 18.069 17.6468 17.6003C18.1154 17.1316 18.3791 16.4962 18.3798 15.8333V4.16667C18.3791 3.50385 18.1154 2.86839 17.6468 2.3997C17.1781 1.93102 16.5426 1.6674 15.8798 1.66667ZM4.21313 3.33334H15.8798C16.1007 3.33356 16.3126 3.42143 16.4688 3.57766C16.625 3.73389 16.7129 3.94573 16.7131 4.16667V10.8333H14.6591C14.3847 10.8331 14.1145 10.9008 13.8725 11.0303C13.6306 11.1597 13.4244 11.3471 13.2724 11.5755L12.1005 13.3333H7.99243L6.82056 11.5755C6.66853 11.3471 6.46237 11.1597 6.22042 11.0303C5.97848 10.9008 5.70826 10.8331 5.43384 10.8333H3.3798V4.16667C3.38002 3.94573 3.46789 3.73389 3.62412 3.57766C3.78035 3.42143 3.99219 3.33356 4.21313 3.33334ZM15.8798 16.6667H4.21313C3.99219 16.6664 3.78035 16.5786 3.62412 16.4223C3.46789 16.2661 3.38002 16.0543 3.3798 15.8333V12.5H5.43384L6.60572 14.2578C6.75774 14.4863 6.96391 14.6736 7.20585 14.8031C7.4478 14.9326 7.71802 15.0002 7.99243 15H12.1005C12.3749 15.0002 12.6451 14.9326 12.8871 14.8031C13.129 14.6736 13.3352 14.4863 13.4872 14.2578L14.6591 12.5H16.7131V15.8333C16.7129 16.0543 16.625 16.2661 16.4688 16.4223C16.3126 16.5786 16.1007 16.6664 15.8798 16.6667Z"
                                fill="#666666"
                              />
                            </svg>
                            Important
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                          as="li"
                          className="nav-item btn-group"
                          role="presentation"
                        >
                          <Nav.Link
                            as="button"
                            className="btn  mx-2 effect nav-link"
                            id="pills-profile-tab"
                            eventKey="Social"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.97602 19.2308H15.0241C17.3438 19.2308 19.2308 17.3437 19.2308 15.024V4.97596C19.2308 2.65624 17.3438 0.769226 15.0241 0.769226H4.97602C2.65631 0.769226 0.769287 2.65624 0.769287 4.97596V15.024C0.769287 17.3437 2.65631 19.2308 4.97602 19.2308ZM2.30775 4.97596C2.30775 3.50473 3.50441 2.30769 4.97602 2.30769H15.0241C16.4957 2.30769 17.6924 3.50473 17.6924 4.97596V15.024C17.6924 16.4953 16.4957 17.6923 15.0241 17.6923H4.97602C3.50441 17.6923 2.30775 16.4953 2.30775 15.024V4.97596Z"
                                fill="#666666"
                              />
                              <path
                                d="M5.87963 15.5848H14.1211C14.6199 15.5848 15.0841 15.361 15.3959 14.9711C15.7099 14.5782 15.8263 14.0711 15.7151 13.5799C15.2867 11.6913 13.9951 10.2069 12.309 9.49022C12.7777 8.95086 13.0716 8.25552 13.0716 7.48648C13.0716 5.7929 11.6939 4.41519 9.99997 4.41519C8.30601 4.41519 6.92831 5.7929 6.92831 7.48648C6.92831 8.25552 7.22222 8.95086 7.69097 9.49022C6.0048 10.2069 4.7133 11.6915 4.28483 13.5802C4.17365 14.0711 4.29009 14.5778 4.60409 14.9707C4.91584 15.361 5.38083 15.5848 5.87963 15.5848ZM8.46677 7.48648C8.46677 6.64138 9.15487 5.95365 9.99997 5.95365C10.8451 5.95365 11.5332 6.64138 11.5332 7.48648C11.5332 8.33158 10.8451 9.01931 9.99997 9.01931C9.15487 9.01931 8.46677 8.33158 8.46677 7.48648ZM9.99997 10.5578C12.032 10.5578 13.765 11.9404 14.2142 13.9198C14.224 13.9618 14.2082 13.9923 14.1939 14.0107C14.1654 14.0464 14.1323 14.0464 14.1211 14.0464H5.87963C5.86836 14.0464 5.83456 14.0464 5.80601 14.0107C5.79174 13.9923 5.77597 13.9618 5.78573 13.9201C6.23495 11.9404 7.96797 10.5578 9.99997 10.5578Z"
                                fill="#666666"
                              />
                            </svg>
                            Socials
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                          as="li"
                          className="nav-item btn-group"
                          role="presentation"
                        >
                          <Nav.Link
                            as="button"
                            className="btn  mx-2 effect nav-link"
                            id="pills-contact-tab"
                            eventKey="Promotion"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.5594 3.68912H16.0558C15.855 3.68912 15.66 3.76101 15.5071 3.89074L14.2974 4.92116L13.0951 3.89239C12.9414 3.76101 12.7464 3.68912 12.5448 3.68912H2.44958C1.49765 3.68912 0.723389 4.46338 0.723389 5.4153V8.40824C0.723389 9.08335 1.15969 9.6659 1.83479 9.89232C2.18267 10.0088 2.4157 10.3311 2.4157 10.6955C2.4157 11.0616 2.1835 11.3838 1.83644 11.4987C1.17043 11.7201 0.723389 12.3167 0.723389 12.9828V16.5847C0.723389 17.5366 1.49765 18.3109 2.44958 18.3109H12.5448C12.7472 18.3109 12.943 18.2382 13.0967 18.106L14.2974 17.0731L15.5055 18.1076C15.6592 18.239 15.8542 18.3109 16.0558 18.3109H19.5511C20.5022 18.3109 21.2765 17.5366 21.2765 16.5847V12.9828C21.2765 12.306 20.8402 11.7234 20.1634 11.4987C19.8172 11.3838 19.5842 11.0616 19.5842 10.6955C19.5842 10.3319 19.818 10.0088 20.1659 9.89232C20.841 9.6659 21.2765 9.08335 21.2765 8.40824V5.40704C21.2765 4.46008 20.5064 3.68912 19.5594 3.68912ZM19.5842 8.3033C18.5703 8.66275 17.8919 9.6188 17.8919 10.6955C17.8919 11.7739 18.567 12.7274 19.5834 13.0894L19.5511 16.6186H16.3681L14.8461 15.3155C14.5288 15.0444 14.0611 15.0461 13.7437 15.3171L12.2324 16.6178L2.4157 16.5847V13.0894C3.42959 12.7324 4.108 11.7763 4.108 10.6955C4.108 9.62128 3.43373 8.66771 2.41652 8.30247L2.44958 5.38143H12.2324L13.7454 6.67627C14.0619 6.94648 14.5263 6.94813 14.8444 6.67792L16.3648 5.3839L19.5842 5.40704V8.3033Z"
                                fill="#666666"
                              />
                              <path
                                d="M14.3337 9.46841C13.866 9.46841 13.4876 9.84687 13.4876 10.3146V11.6854C13.4876 12.1531 13.866 12.5316 14.3337 12.5316C14.8014 12.5316 15.1799 12.1531 15.1799 11.6854V10.3146C15.1799 9.84687 14.8014 9.46841 14.3337 9.46841ZM10.7359 9.32546L10.0162 9.22051L9.69477 8.56937C9.69477 8.56937 9.69477 8.56937 9.69477 8.56855C9.47001 8.11407 9.01554 7.83147 8.50817 7.83147C8.00081 7.83147 7.54633 8.11407 7.32158 8.56937L7.00014 9.22051L6.28206 9.32463C5.78048 9.39735 5.37063 9.74192 5.21363 10.2245C5.05663 10.7071 5.18471 11.2277 5.54829 11.5813L6.06804 12.0887L5.94575 12.8043C5.85981 13.305 6.06143 13.8008 6.47212 14.0991C6.88243 14.397 7.41676 14.4352 7.86447 14.1999L8.50817 13.8611L9.15023 14.1991C9.59892 14.4354 10.1319 14.3974 10.5442 14.0991C10.9549 13.8008 11.1565 13.305 11.0706 12.8051L10.9483 12.0887L11.4689 11.5813C11.8325 11.226 11.9597 10.7062 11.8027 10.2237C11.6457 9.7411 11.2359 9.39735 10.7359 9.32546ZM9.62949 11.0112C9.31714 11.3144 9.17419 11.7524 9.24773 12.1837L9.27665 12.3539L9.12626 12.2746C8.74101 12.0704 8.28108 12.0695 7.89256 12.2729L7.73969 12.3531L7.76862 12.1829C7.84216 11.7524 7.6992 11.3144 7.38851 11.0128L7.26456 10.8922L7.43478 10.8674C7.8653 10.8054 8.23797 10.5352 8.43133 10.1435L8.50817 9.98817L8.58502 10.1443C8.77838 10.5352 9.15105 10.8054 9.57991 10.8665L9.75179 10.8922L9.62949 11.0112Z"
                                fill="#666666"
                              />
                            </svg>
                            Promotion
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                    <div className="mail-tools">
                      <Link to={"#"}>
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.1668 21.8333H21.8335C22.0766 21.8333 22.3098 21.7368 22.4817 21.5648C22.6536 21.3929 22.7502 21.1598 22.7502 20.9167C22.7502 20.6736 22.6536 20.4404 22.4817 20.2685C22.3098 20.0966 22.0766 20 21.8335 20H18.1668C17.9237 20 17.6906 20.0966 17.5186 20.2685C17.3467 20.4404 17.2502 20.6736 17.2502 20.9167C17.2502 21.1598 17.3467 21.3929 17.5186 21.5648C17.6906 21.7368 17.9237 21.8333 18.1668 21.8333ZM26.4168 11.75H13.5835C12.8542 11.75 12.1547 12.0397 11.639 12.5555C11.1232 13.0712 10.8335 13.7707 10.8335 14.5V17.25C10.8335 17.4931 10.9301 17.7263 11.102 17.8982C11.2739 18.0701 11.507 18.1667 11.7502 18.1667H12.6668V25.5C12.6668 26.2293 12.9566 26.9288 13.4723 27.4445C13.988 27.9603 14.6875 28.25 15.4168 28.25H24.5835C25.3128 28.25 26.0123 27.9603 26.528 27.4445C27.0438 26.9288 27.3335 26.2293 27.3335 25.5V18.1667H28.2502C28.4933 18.1667 28.7264 18.0701 28.8983 17.8982C29.0703 17.7263 29.1668 17.4931 29.1668 17.25V14.5C29.1668 13.7707 28.8771 13.0712 28.3614 12.5555C27.8456 12.0397 27.1462 11.75 26.4168 11.75ZM25.5002 25.5C25.5002 25.7431 25.4036 25.9763 25.2317 26.1482C25.0598 26.3201 24.8266 26.4167 24.5835 26.4167H15.4168C15.1737 26.4167 14.9406 26.3201 14.7686 26.1482C14.5967 25.9763 14.5002 25.7431 14.5002 25.5V18.1667H25.5002V25.5ZM27.3335 16.3333H12.6668V14.5C12.6668 14.2569 12.7634 14.0237 12.9353 13.8518C13.1072 13.6799 13.3404 13.5833 13.5835 13.5833H26.4168C26.6599 13.5833 26.8931 13.6799 27.065 13.8518C27.2369 14.0237 27.3335 14.2569 27.3335 14.5V16.3333Z"
                            fill="#01A3FF"
                          />
                        </svg>
                      </Link>
                      <Link to={"#"}>
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.0002 14.5C19.8798 14.5 19.7606 14.5237 19.6493 14.5697C19.5381 14.6158 19.437 14.6833 19.3519 14.7684C19.2668 14.8535 19.1993 14.9546 19.1532 15.0658C19.1072 15.1771 19.0835 15.2963 19.0835 15.4167V19.4351L16.8554 20.5563C16.7479 20.6104 16.6521 20.6851 16.5735 20.7762C16.4948 20.8673 16.4349 20.973 16.3971 21.0873C16.3594 21.2016 16.3444 21.3221 16.3533 21.4421C16.3621 21.5622 16.3945 21.6793 16.4485 21.7868C16.5026 21.8943 16.5773 21.9901 16.6684 22.0687C16.7595 22.1473 16.8652 22.2073 16.9795 22.245C17.0937 22.2828 17.2143 22.2977 17.3343 22.2889C17.4543 22.2801 17.5714 22.2477 17.679 22.1936L20.412 20.8186C20.5638 20.7425 20.6914 20.6255 20.7806 20.481C20.8697 20.3364 20.9169 20.1699 20.9168 20V15.4167C20.9169 15.2963 20.8932 15.1771 20.8471 15.0658C20.8011 14.9546 20.7335 14.8535 20.6484 14.7684C20.5633 14.6833 20.4622 14.6158 20.351 14.5697C20.2398 14.5237 20.1206 14.5 20.0002 14.5ZM20.0002 10.8333C18.1872 10.8333 16.4149 11.3709 14.9074 12.3782C13.4 13.3854 12.2251 14.8171 11.5313 16.4921C10.8375 18.1671 10.6559 20.0102 11.0096 21.7883C11.3633 23.5665 12.2364 25.1998 13.5184 26.4818C14.8003 27.7638 16.4337 28.6368 18.2118 28.9905C19.99 29.3442 21.8331 29.1627 23.5081 28.4689C25.1831 27.7751 26.6147 26.6002 27.622 25.0927C28.6292 23.5853 29.1668 21.813 29.1668 20C29.1641 17.5697 28.1974 15.2397 26.4789 13.5213C24.7604 11.8028 22.4305 10.8361 20.0002 10.8333ZM20.0002 27.3333C18.5498 27.3333 17.1319 26.9032 15.926 26.0974C14.72 25.2916 13.7801 24.1463 13.2251 22.8063C12.67 21.4663 12.5248 19.9919 12.8077 18.5693C13.0907 17.1468 13.7891 15.8401 14.8147 14.8145C15.8403 13.789 17.147 13.0905 18.5695 12.8076C19.992 12.5246 21.4665 12.6698 22.8065 13.2249C24.1465 13.7799 25.2918 14.7199 26.0976 15.9258C26.9034 17.1318 27.3335 18.5496 27.3335 20C27.3313 21.9442 26.5579 23.8082 25.1832 25.183C23.8084 26.5578 21.9444 27.3311 20.0002 27.3333Z"
                            fill="#01A3FF"
                          />
                        </svg>
                      </Link>
                      <Link to={"#"}>
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.1667 25.5C18.4098 25.5 18.6429 25.4035 18.8148 25.2316C18.9868 25.0596 19.0833 24.8265 19.0833 24.5834V19.0834C19.0833 18.8403 18.9868 18.6071 18.8148 18.4352C18.6429 18.2633 18.4098 18.1667 18.1667 18.1667C17.9236 18.1667 17.6904 18.2633 17.5185 18.4352C17.3466 18.6071 17.25 18.8403 17.25 19.0834V24.5834C17.25 24.8265 17.3466 25.0596 17.5185 25.2316C17.6904 25.4035 17.9236 25.5 18.1667 25.5ZM27.3333 14.5H23.6667V13.5834C23.6667 12.854 23.3769 12.1546 22.8612 11.6388C22.3455 11.1231 21.646 10.8334 20.9167 10.8334H19.0833C18.354 10.8334 17.6545 11.1231 17.1388 11.6388C16.6231 12.1546 16.3333 12.854 16.3333 13.5834V14.5H12.6667C12.4236 14.5 12.1904 14.5966 12.0185 14.7685C11.8466 14.9404 11.75 15.1736 11.75 15.4167C11.75 15.6598 11.8466 15.893 12.0185 16.0649C12.1904 16.2368 12.4236 16.3334 12.6667 16.3334H13.5833V26.4167C13.5833 27.1461 13.8731 27.8455 14.3888 28.3612C14.9045 28.877 15.604 29.1667 16.3333 29.1667H23.6667C24.396 29.1667 25.0955 28.877 25.6112 28.3612C26.1269 27.8455 26.4167 27.1461 26.4167 26.4167V16.3334H27.3333C27.5764 16.3334 27.8096 16.2368 27.9815 16.0649C28.1534 15.893 28.25 15.6598 28.25 15.4167C28.25 15.1736 28.1534 14.9404 27.9815 14.7685C27.8096 14.5966 27.5764 14.5 27.3333 14.5ZM18.1667 13.5834C18.1667 13.3403 18.2632 13.1071 18.4352 12.9352C18.6071 12.7633 18.8402 12.6667 19.0833 12.6667H20.9167C21.1598 12.6667 21.3929 12.7633 21.5648 12.9352C21.7368 13.1071 21.8333 13.3403 21.8333 13.5834V14.5H18.1667V13.5834ZM24.5833 26.4167C24.5833 26.6598 24.4868 26.893 24.3148 27.0649C24.1429 27.2368 23.9098 27.3334 23.6667 27.3334H16.3333C16.0902 27.3334 15.8571 27.2368 15.6852 27.0649C15.5132 26.893 15.4167 26.6598 15.4167 26.4167V16.3334H24.5833V26.4167ZM21.8333 25.5C22.0764 25.5 22.3096 25.4035 22.4815 25.2316C22.6534 25.0596 22.75 24.8265 22.75 24.5834V19.0834C22.75 18.8403 22.6534 18.6071 22.4815 18.4352C22.3096 18.2633 22.0764 18.1667 21.8333 18.1667C21.5902 18.1667 21.3571 18.2633 21.1852 18.4352C21.0132 18.6071 20.9167 18.8403 20.9167 19.0834V24.5834C20.9167 24.8265 21.0132 25.0596 21.1852 25.2316C21.3571 25.4035 21.5902 25.5 21.8333 25.5Z"
                            fill="#01A3FF"
                          />
                        </svg>
                      </Link>
                      <Link to={"#"}>
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M28.5435 17.7542L26.811 17.1767L27.6268 15.545C27.7095 15.3742 27.7372 15.182 27.706 14.9948C27.6748 14.8076 27.5863 14.6347 27.4527 14.5L25.5002 12.5475C25.3647 12.4119 25.1902 12.3222 25.0011 12.2909C24.812 12.2597 24.6179 12.2885 24.446 12.3733L22.8143 13.1892L22.2368 11.4567C22.1758 11.2761 22.0601 11.119 21.9056 11.0073C21.7512 10.8955 21.5658 10.8347 21.3752 10.8333H18.6252C18.433 10.8328 18.2455 10.8927 18.0893 11.0046C17.933 11.1165 17.8158 11.2746 17.7543 11.4567L17.1768 13.1892L15.5452 12.3733C15.3744 12.2906 15.1821 12.263 14.995 12.2942C14.8078 12.3254 14.6349 12.4139 14.5002 12.5475L12.5477 14.5C12.4121 14.6354 12.3224 14.81 12.2911 14.9991C12.2599 15.1882 12.2887 15.3823 12.3735 15.5542L13.1893 17.1858L11.4568 17.7633C11.2762 17.8243 11.1192 17.9401 11.0074 18.0945C10.8957 18.249 10.8349 18.4344 10.8335 18.625V21.375C10.833 21.5672 10.8929 21.7546 11.0048 21.9109C11.1166 22.0672 11.2748 22.1843 11.4568 22.2458L13.1893 22.8233L12.3735 24.455C12.2908 24.6258 12.2631 24.818 12.2943 25.0052C12.3255 25.1924 12.414 25.3653 12.5477 25.5L14.5002 27.4525C14.6356 27.5881 14.8102 27.6778 14.9992 27.709C15.1883 27.7403 15.3825 27.7115 15.5543 27.6267L17.186 26.8108L17.7635 28.5433C17.825 28.7254 17.9422 28.8835 18.0984 28.9954C18.2547 29.1072 18.4422 29.1672 18.6343 29.1667H21.3843C21.5765 29.1672 21.764 29.1072 21.9202 28.9954C22.0765 28.8835 22.1937 28.7254 22.2552 28.5433L22.8327 26.8108L24.4643 27.6267C24.634 27.7073 24.8244 27.7338 25.0097 27.7027C25.1949 27.6715 25.3662 27.5842 25.5002 27.4525L27.4527 25.5C27.5883 25.3645 27.678 25.19 27.7092 25.0009C27.7405 24.8118 27.7116 24.6177 27.6268 24.4458L26.811 22.8142L28.5435 22.2367C28.7241 22.1757 28.8812 22.0599 28.9929 21.9055C29.1046 21.751 29.1654 21.5656 29.1668 21.375V18.625C29.1673 18.4328 29.1074 18.2454 28.9956 18.0891C28.8837 17.9328 28.7256 17.8157 28.5435 17.7542ZM27.3335 20.715L26.2335 21.0817C25.9805 21.1637 25.7485 21.2998 25.5534 21.4805C25.3583 21.6612 25.2048 21.8822 25.1037 22.1281C25.0025 22.374 24.9561 22.639 24.9675 22.9047C24.979 23.1704 25.0482 23.4304 25.1702 23.6667L25.6927 24.7117L24.6843 25.72L23.6668 25.17C23.4318 25.0529 23.1743 24.9876 22.9118 24.9787C22.6493 24.9697 22.388 25.0173 22.1455 25.1181C21.9029 25.2189 21.6849 25.3707 21.5062 25.5631C21.3274 25.7555 21.1921 25.9841 21.1093 26.2333L20.7427 27.3333H19.2852L18.9185 26.2333C18.8364 25.9804 18.7004 25.7483 18.5197 25.5532C18.339 25.3581 18.118 25.2047 17.8721 25.1035C17.6261 25.0023 17.3611 24.9559 17.0955 24.9674C16.8298 24.9789 16.5698 25.048 16.3335 25.17L15.2885 25.6925L14.2802 24.6842L14.8302 23.6667C14.9522 23.4304 15.0213 23.1704 15.0328 22.9047C15.0443 22.639 14.9978 22.374 14.8967 22.1281C14.7955 21.8822 14.642 21.6612 14.4469 21.4805C14.2519 21.2998 14.0198 21.1637 13.7668 21.0817L12.6668 20.715V19.285L13.7668 18.9183C14.0198 18.8363 14.2519 18.7002 14.4469 18.5195C14.642 18.3388 14.7955 18.1178 14.8967 17.8719C14.9978 17.626 15.0443 17.361 15.0328 17.0953C15.0213 16.8296 14.9522 16.5696 14.8302 16.3333L14.3077 15.3158L15.316 14.3075L16.3335 14.83C16.5698 14.952 16.8298 15.0211 17.0955 15.0326C17.3611 15.0441 17.6261 14.9977 17.8721 14.8965C18.118 14.7953 18.339 14.6419 18.5197 14.4468C18.7004 14.2517 18.8364 14.0196 18.9185 13.7667L19.2852 12.6667H20.7152L21.0818 13.7667C21.1639 14.0196 21.3 14.2517 21.4807 14.4468C21.6614 14.6419 21.8824 14.7953 22.1283 14.8965C22.3742 14.9977 22.6392 15.0441 22.9049 15.0326C23.1706 15.0211 23.4305 14.952 23.6668 14.83L24.7118 14.3075L25.7202 15.3158L25.1702 16.3333C25.053 16.5684 24.9878 16.8259 24.9789 17.0884C24.9699 17.3509 25.0174 17.6122 25.1183 17.8547C25.2191 18.0972 25.3709 18.3152 25.5633 18.494C25.7557 18.6727 25.9842 18.8081 26.2335 18.8908L27.3335 19.2575V20.715ZM20.0002 16.3333C19.275 16.3333 18.5661 16.5484 17.9631 16.9513C17.3601 17.3542 16.8901 17.9268 16.6126 18.5968C16.3351 19.2668 16.2625 20.0041 16.404 20.7153C16.5454 21.4266 16.8946 22.0799 17.4074 22.5927C17.9202 23.1055 18.5736 23.4547 19.2848 23.5962C19.9961 23.7377 20.7333 23.6651 21.4033 23.3876C22.0733 23.11 22.646 22.6401 23.0489 22.0371C23.4518 21.4341 23.6668 20.7252 23.6668 20C23.6668 19.0275 23.2805 18.0949 22.5929 17.4073C21.9053 16.7196 20.9726 16.3333 20.0002 16.3333ZM20.0002 21.8333C19.6376 21.8333 19.2831 21.7258 18.9816 21.5244C18.6801 21.3229 18.4451 21.0366 18.3064 20.7016C18.1676 20.3666 18.1313 19.998 18.2021 19.6423C18.2728 19.2867 18.4474 18.96 18.7038 18.7036C18.9602 18.4472 19.2869 18.2726 19.6425 18.2019C19.9981 18.1312 20.3668 18.1675 20.7018 18.3062C21.0367 18.445 21.3231 18.68 21.5245 18.9815C21.726 19.2829 21.8335 19.6374 21.8335 20C21.8335 20.4862 21.6403 20.9525 21.2965 21.2964C20.9527 21.6402 20.4864 21.8333 20.0002 21.8333Z"
                            fill="#01A3FF"
                          />
                        </svg>
                      </Link>
                      <Link to={"#"}>
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_725_283)">
                            <path
                              d="M22.8101 19.5011C22.8101 19.1976 22.7503 18.897 22.6341 18.6167C22.518 18.3363 22.3478 18.0815 22.1332 17.8669C21.9186 17.6523 21.6638 17.4821 21.3834 17.3659C21.103 17.2498 20.8025 17.19 20.499 17.19C20.1955 17.19 19.895 17.2498 19.6146 17.3659C19.3342 17.4821 19.0795 17.6523 18.8649 17.8669C18.6503 18.0815 18.48 18.3363 18.3639 18.6167C18.2477 18.897 18.188 19.1976 18.188 19.5011C18.1881 20.114 18.4317 20.7018 18.8652 21.1351C19.2987 21.5684 19.8866 21.8117 20.4995 21.8116C21.1125 21.8114 21.7002 21.5678 22.1335 21.1343C22.5668 20.7008 22.8102 20.1129 22.8101 19.5L22.8101 19.5011ZM22.8101 12.1511C22.8101 11.8476 22.7503 11.5471 22.6341 11.2667C22.518 10.9863 22.3478 10.7315 22.1332 10.5169C21.9186 10.3023 21.6638 10.1321 21.3834 10.0159C21.103 9.89979 20.8025 9.84001 20.499 9.84001C20.1955 9.84001 19.895 9.89979 19.6146 10.0159C19.3342 10.1321 19.0795 10.3023 18.8649 10.5169C18.6503 10.7315 18.48 10.9863 18.3639 11.2667C18.2477 11.5471 18.188 11.8476 18.188 12.1511C18.1881 12.764 18.4317 13.3518 18.8652 13.7851C19.2987 14.2184 19.8866 14.4617 20.4995 14.4616C21.1125 14.4614 21.7002 14.2178 22.1335 13.7843C22.5668 13.3508 22.8102 12.7629 22.8101 12.15L22.8101 12.1511ZM22.8101 26.8511C22.8101 26.5476 22.7503 26.247 22.6341 25.9667C22.518 25.6863 22.3478 25.4315 22.1332 25.2169C21.9186 25.0023 21.6638 24.8321 21.3834 24.7159C21.103 24.5998 20.8025 24.54 20.499 24.54C20.1955 24.54 19.895 24.5998 19.6146 24.7159C19.3342 24.8321 19.0795 25.0023 18.8649 25.2169C18.6502 25.4315 18.48 25.6863 18.3639 25.9667C18.2477 26.247 18.188 26.5476 18.188 26.8511C18.1881 27.464 18.4317 28.0518 18.8652 28.4851C19.2987 28.9184 19.8866 29.1617 20.4995 29.1616C21.1125 29.1614 21.7002 28.9178 22.1335 28.4843C22.5668 28.0508 22.8102 27.4629 22.8101 26.85L22.8101 26.8511Z"
                              fill="#01A3FF"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_725_283">
                              <rect
                                width="21"
                                height="21"
                                fill="white"
                                transform="translate(31 9) rotate(90)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
                {/** Single Message */}
                <Tab.Content>
                  <div className="email-list">
                    {messageBlog.map((data, ind) => (
                      <div className="message" key={ind}>
                        <div>
                          <div className="d-flex message-single">
                            <div className="ps-1 align-self-center">
                              <div className="form-check custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  onClick={() => chackboxFun()}
                                  id="checkbox2"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="checkbox2"
                                />
                              </div>
                            </div>
                            <div className="ms-2">
                              <label className="bookmark-btn">
                                <input type="checkbox" />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                          </div>
                          <Link to="email-read" className="col-mail col-mail-2">
                            <div className="hader">UI Design Beginner</div>
                            <div className="subject">
                              working time in this pandemic
                              <span>
                                {" "}
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit
                              </span>
                            </div>
                            <div className="date">11:49 AM</div>
                          </Link>
                          <div className="icon">
                            <Link to={"#"}>
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.16683 12.8333H12.8335C13.0766 12.8333 13.3098 12.7368 13.4817 12.5648C13.6536 12.3929 13.7502 12.1598 13.7502 11.9167C13.7502 11.6736 13.6536 11.4404 13.4817 11.2685C13.3098 11.0966 13.0766 11 12.8335 11H9.16683C8.92371 11 8.69056 11.0966 8.51865 11.2685C8.34674 11.4404 8.25016 11.6736 8.25016 11.9167C8.25016 12.1598 8.34674 12.3929 8.51865 12.5648C8.69056 12.7368 8.92371 12.8333 9.16683 12.8333V12.8333ZM17.4168 2.75H4.5835C3.85415 2.75 3.15468 3.03973 2.63895 3.55546C2.12323 4.07118 1.8335 4.77065 1.8335 5.5V8.25C1.8335 8.49312 1.93007 8.72627 2.10198 8.89818C2.27389 9.07009 2.50705 9.16667 2.75016 9.16667H3.66683V16.5C3.66683 17.2293 3.95656 17.9288 4.47229 18.4445C4.98801 18.9603 5.68748 19.25 6.41683 19.25H15.5835C16.3128 19.25 17.0123 18.9603 17.528 18.4445C18.0438 17.9288 18.3335 17.2293 18.3335 16.5V9.16667H19.2502C19.4933 9.16667 19.7264 9.07009 19.8983 8.89818C20.0703 8.72627 20.1668 8.49312 20.1668 8.25V5.5C20.1668 4.77065 19.8771 4.07118 19.3614 3.55546C18.8456 3.03973 18.1462 2.75 17.4168 2.75ZM16.5002 16.5C16.5002 16.7431 16.4036 16.9763 16.2317 17.1482C16.0598 17.3201 15.8266 17.4167 15.5835 17.4167H6.41683C6.17371 17.4167 5.94056 17.3201 5.76865 17.1482C5.59674 16.9763 5.50016 16.7431 5.50016 16.5V9.16667H16.5002V16.5ZM18.3335 7.33333H3.66683V5.5C3.66683 5.25688 3.76341 5.02373 3.93531 4.85182C4.10722 4.67991 4.34038 4.58333 4.5835 4.58333H17.4168C17.6599 4.58333 17.8931 4.67991 18.065 4.85182C18.2369 5.02373 18.3335 5.25688 18.3335 5.5V7.33333Z"
                                  fill="#666666"
                                />
                              </svg>
                            </Link>
                            <Link to={"#"} className="ms-2">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0002 5.5C10.8798 5.49997 10.7606 5.52366 10.6493 5.56972C10.5381 5.61577 10.437 5.68329 10.3519 5.76842C10.2668 5.85354 10.1993 5.95461 10.1532 6.06584C10.1072 6.17707 10.0835 6.29628 10.0835 6.41667V10.4351L7.85539 11.5564C7.74789 11.6104 7.65209 11.6852 7.57346 11.7763C7.49483 11.8674 7.43491 11.973 7.39713 12.0873C7.35935 12.2016 7.34444 12.3221 7.35326 12.4422C7.36208 12.5622 7.39445 12.6793 7.44853 12.7868C7.5026 12.8943 7.57732 12.9901 7.66842 13.0687C7.75953 13.1473 7.86522 13.2073 7.97948 13.245C8.09373 13.2828 8.21431 13.2977 8.33433 13.2889C8.45434 13.2801 8.57145 13.2477 8.67896 13.1936L11.412 11.8186C11.5638 11.7425 11.6914 11.6255 11.7806 11.481C11.8697 11.3364 11.9169 11.1699 11.9168 11V6.41667C11.9169 6.29628 11.8932 6.17707 11.8471 6.06584C11.8011 5.95461 11.7335 5.85354 11.6484 5.76842C11.5633 5.68329 11.4622 5.61577 11.351 5.56972C11.2398 5.52366 11.1206 5.49997 11.0002 5.5V5.5ZM11.0002 1.83334C9.18717 1.83334 7.41489 2.37095 5.90744 3.3782C4.39999 4.38544 3.22507 5.81708 2.53127 7.49207C1.83747 9.16706 1.65594 11.0102 2.00964 12.7883C2.36333 14.5665 3.23637 16.1998 4.51835 17.4818C5.80034 18.7638 7.43368 19.6368 9.21184 19.9905C10.99 20.3442 12.8331 20.1627 14.5081 19.4689C16.1831 18.7751 17.6147 17.6002 18.622 16.0927C19.6292 14.5853 20.1668 12.813 20.1668 11C20.1641 8.5697 19.1974 6.23974 17.4789 4.52126C15.7604 2.80278 13.4305 1.83612 11.0002 1.83334V1.83334ZM11.0002 18.3333C9.54977 18.3333 8.13195 17.9032 6.92598 17.0974C5.72002 16.2916 4.78009 15.1463 4.22505 13.8063C3.67001 12.4664 3.52478 10.9919 3.80774 9.56934C4.0907 8.14681 4.78913 6.84014 5.81472 5.81455C6.8403 4.78897 8.14698 4.09054 9.5695 3.80758C10.992 3.52462 12.4665 3.66984 13.8065 4.22489C15.1465 4.77993 16.2918 5.71986 17.0976 6.92582C17.9034 8.13178 18.3335 9.54961 18.3335 11C18.3313 12.9442 17.5579 14.8082 16.1832 16.183C14.8084 17.5578 12.9444 18.3311 11.0002 18.3333V18.3333Z"
                                  fill="#666666"
                                />
                              </svg>
                            </Link>
                            <Link to={"#"} className="ms-2">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.16667 16.5C9.40978 16.5 9.64294 16.4035 9.81485 16.2316C9.98676 16.0596 10.0833 15.8265 10.0833 15.5834V10.0834C10.0833 9.84026 9.98676 9.6071 9.81485 9.43519C9.64294 9.26328 9.40978 9.16671 9.16667 9.16671C8.92355 9.16671 8.69039 9.26328 8.51849 9.43519C8.34658 9.6071 8.25 9.84026 8.25 10.0834V15.5834C8.25 15.8265 8.34658 16.0596 8.51849 16.2316C8.69039 16.4035 8.92355 16.5 9.16667 16.5ZM18.3333 5.50004H14.6667V4.58337C14.6667 3.85403 14.3769 3.15456 13.8612 2.63883C13.3455 2.12311 12.646 1.83337 11.9167 1.83337H10.0833C9.35399 1.83337 8.65451 2.12311 8.13879 2.63883C7.62306 3.15456 7.33333 3.85403 7.33333 4.58337V5.50004H3.66667C3.42355 5.50004 3.19039 5.59662 3.01849 5.76853C2.84658 5.94043 2.75 6.17359 2.75 6.41671C2.75 6.65982 2.84658 6.89298 3.01849 7.06489C3.19039 7.2368 3.42355 7.33337 3.66667 7.33337H4.58333V17.4167C4.58333 18.1461 4.87306 18.8455 5.38879 19.3613C5.90451 19.877 6.60399 20.1667 7.33333 20.1667H14.6667C15.396 20.1667 16.0955 19.877 16.6112 19.3613C17.1269 18.8455 17.4167 18.1461 17.4167 17.4167V7.33337H18.3333C18.5764 7.33337 18.8096 7.2368 18.9815 7.06489C19.1534 6.89298 19.25 6.65982 19.25 6.41671C19.25 6.17359 19.1534 5.94043 18.9815 5.76853C18.8096 5.59662 18.5764 5.50004 18.3333 5.50004ZM9.16667 4.58337C9.16667 4.34026 9.26324 4.1071 9.43515 3.93519C9.60706 3.76328 9.84022 3.66671 10.0833 3.66671H11.9167C12.1598 3.66671 12.3929 3.76328 12.5648 3.93519C12.7368 4.1071 12.8333 4.34026 12.8333 4.58337V5.50004H9.16667V4.58337ZM15.5833 17.4167C15.5833 17.6598 15.4868 17.893 15.3148 18.0649C15.1429 18.2368 14.9098 18.3334 14.6667 18.3334H7.33333C7.09022 18.3334 6.85706 18.2368 6.68515 18.0649C6.51324 17.893 6.41667 17.6598 6.41667 17.4167V7.33337H15.5833V17.4167ZM12.8333 16.5C13.0764 16.5 13.3096 16.4035 13.4815 16.2316C13.6534 16.0596 13.75 15.8265 13.75 15.5834V10.0834C13.75 9.84026 13.6534 9.6071 13.4815 9.43519C13.3096 9.26328 13.0764 9.16671 12.8333 9.16671C12.5902 9.16671 12.3571 9.26328 12.1852 9.43519C12.0132 9.6071 11.9167 9.84026 11.9167 10.0834V15.5834C11.9167 15.8265 12.0132 16.0596 12.1852 16.2316C12.3571 16.4035 12.5902 16.5 12.8333 16.5Z"
                                  fill="#666666"
                                />
                              </svg>
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Tab.Content>
                <div className="row">
                  <div className="col-12 ps-3">
                    {/* <div className="dataTables_info">
                                    Showing {activePag.current * sort + 1} to{" "}
                                    {data.length > (activePag.current + 1) * sort
                                        ? (activePag.current + 1) * sort
                                        : data.length}{" "}
                                    of {data.length} entries
                                </div> */}
                    <nav>
                      <ul className="pagination pagination-gutter pagination-primary pagination-sm no-bg">
                        <li className="page-item page-indicator">
                          <Link
                            className="page-link"
                            to="/email-inbox"
                            onClick={() =>
                              activePag.current > 0 &&
                              onClick(activePag.current - 1)
                            }
                          >
                            <i className="la la-angle-left"></i>
                          </Link>
                        </li>
                        {paggination.map((number, i) => (
                          <li
                            key={i}
                            className={`page-item  ${
                              activePag.current === i ? "active" : ""
                            } `}
                            onClick={() => onClick(i)}
                          >
                            <Link className="page-link" to="/email-inbox">
                              {number}
                            </Link>
                          </li>
                        ))}

                        <li className="page-item page-indicator">
                          <Link
                            className="page-link"
                            to="/email-inbox"
                            onClick={() =>
                              activePag.current + 1 < paggination.length &&
                              onClick(activePag.current + 1)
                            }
                          >
                            <i className="la la-angle-right"></i>
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Inbox;
